<div>
    <div class="rule-warning-container" *ngIf="rulesErrorMessages.length > 0">
        <div class="rule-warning" *ngFor="let promptIncomplete of rulesErrorMessages">
            <i class="icon_solid_white_alert i24"></i>
            <p>{{ promptIncomplete | translate }}</p>
        </div>
    </div>
</div>
